export default "__VITE_ASSET__BQP$mEEN__"